// @flow
/**
 * User: Mike Chung
 * Date: 6/1/2018
 * Time: 8:32 PM
 */

import React from 'react';
import {Field} from "redux-form";
import {Button, FormGroup, Input, InputGroup, InputGroupAddon, Label} from "reactstrap";

const renderTextField = ({
                             input,
                             label,
                             className,
                             meta: {touched, error, warning},
                             suffixButtonLabel,
                             suffixButtonOnClick,
                             ...rest
                         }) => {
        if (touched && warning) {
            className += " is-invalid";
        }
        return (
            <FormGroup>
                {label &&
                <Label for={input.id}>{label}</Label>
                }
                <InputGroup>
                    <Input className={className} {...input} {...rest}/>
                    {
                        suffixButtonLabel &&
                        <InputGroupAddon addonType="append"><Button onClick={suffixButtonOnClick}>{suffixButtonLabel}</Button></InputGroupAddon>
                    }
                </InputGroup>
                {
                    touched && warning &&
                    <div className={"invalid-feedback"}>{warning}</div>
                }
            </FormGroup>
        )
    }

;
export default function ReduxFormTextField(props: any) {

    return (
        <Field component={renderTextField} {...props} />
    );
}


// WEBPACK FOOTER //
// ./src/components/form/ReduxFormTextField.js